import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";
import { useState } from "react";
import { InputField, InputTextArea } from "../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { askForRevision } from "../../ducks/services";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  proposalDocId: string;
}

interface FormValues {
  first_name: string;
  last_name: string;
  comments: string;
}

const RevisionModal = (props: PropsType) => {
  const { onClose, proposalDocId } = props;
  const [loading, setLoading] = useState(false);
  const locationUrl = window.location.pathname;
  const pathSegments = locationUrl.split("/");
  const proposalId = pathSegments[pathSegments.length - 1];
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onCloseHandler = () => {
    onClose();
  };

  const onSubmit = async (val: FormValues) => {
    setLoading(true);

    const payload = {
      proposal_id: proposalId,
      proposal_doc_id: proposalDocId,
      comments: val?.comments,
      first_name: val?.first_name,
      last_name: val?.last_name,
    };

    askForRevision(payload)
      .then((res) => {
        if (res) {
          setLoading(false);
          SuccessMessage("Revision request sent");
          onCloseHandler();
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="signFormModal">
        <div className="signFormHeader">
          <h2 style={{ marginBottom: "12px" }}>Ask for a revision</h2>
          <p style={{ marginBottom: "20px" }}>
            Please describe the changes you would like to make. We’ll revise
            this shortly.
          </p>
        </div>

        <div className="modal_content">
          <Form
            layout="vertical"
            onFinish={handleSubmit(onSubmit)}
            onKeyDown={(e) => {
              if (e.key === "Enter") e.preventDefault();
            }}
          >
            <Row gutter={8}>
              <Col span={12}>
                <InputField
                  fieldName="first_name"
                  label="First name"
                  control={control}
                  defaultValue=""
                  iProps={{ placeholder: "Enter first name" }}
                  isRequired
                  rules={{ required: "First name is required." }}
                  validate={errors.first_name && "error"}
                  validMessage={errors.first_name && errors.first_name.message}
                />
              </Col>
              <Col span={12}>
                <InputField
                  fieldName="last_name"
                  label="Last name"
                  control={control}
                  defaultValue=""
                  iProps={{ placeholder: "Enter last name" }}
                  isRequired
                  rules={{ required: "Last name is required." }}
                  validate={errors.last_name && "error"}
                  validMessage={errors.last_name && errors.last_name.message}
                />
              </Col>

              <Col span={24}>
                <InputTextArea
                  fieldName="comments"
                  label="Comments"
                  control={control}
                  defaultValue=""
                  iProps={{
                    placeholder:
                      "Tell us how we can make this better for you ...",
                  }}
                  isRequired
                  rules={{ required: "Comments are required." }}
                  validate={errors.comments && "error"}
                  validMessage={errors.comments && errors.comments.message}
                />
              </Col>

              <Col span={24}>
                <div
                  style={{
                    paddingTop: "4px",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <Button
                    htmlType="button"
                    className="outlined-btn"
                    onClick={onClose}
                  >
                    Cancel
                  </Button>
                  <Button htmlType="submit" type="primary" className="mint-btn">
                    Send request
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Spin>
  );
};

export default RevisionModal;
